import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const DoubleChevronRight: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path d="M12.75 20.25L20.25 12L12.75 3.75" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M3.75 20.25L12 12L3.75 3.75" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default DoubleChevronRight;